/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

const CONTACT_BASE_LINK = '/admin/contacts'

export function getContactCreateLink () {
  return `${CONTACT_BASE_LINK}/create`
}

export function getContactLink (id: number) {
  return `${CONTACT_BASE_LINK}/${id}/edit`
}

export function getContactListLink () {
  return CONTACT_BASE_LINK
}
